export const DECORATION_CONVERTATION_COST: number = 400;
export const DECORATION_PIXELIZATION_COST: number = 500;
export const DECORATION_RESTRICT_PIXELIZATION_COST: number = 2000;
